<template>
  <div>
    <div v-if="terms" style="text-align: center;">
      <div class="terms-box terms-text" ref="termsBox" @scroll="onScroll">
        {{ terms }}
      </div>
      <div class="terms-checkbox-wrapper" :class="{ 'is-readonly': readonly }">
        <el-checkbox :value="agree" :disabled="readonly || !unlocked" size="medium" @change="emitAgree">
          <span :style="agreeLabelStyle">我已閱讀並同意</span>
        </el-checkbox>
      </div>
    </div>
    <div v-else>
      目前尚未有條款內容，請前往美容服務設定頁面新增條款內容。
    </div>
  </div>
</template>

<script>
export default {
  components: 'Terms',
  props: {
    terms: {
      type: String,
      default: '',
    },
    agree: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      unlocked: false,
    }
  },
  computed: {
    agreeLabelStyle() {
      return {
        color: this.agree ? '#ea6a2a' : '#999',
        fontWeight: 'bold',
      }
    },
  },
  watch: {
    readonly: {
      immediate: true,
      handler(val) {
        if (val) {
          this.unlocked = true
        }
      },
    },
  },
  methods: {
    onScroll() {
      if (this.readonly) return
      const el = this.$refs.termsBox
      // 防止 el 為空時出錯
      if (!el) return
      const atBottom = Math.ceil(el.scrollTop + el.clientHeight) >= el.scrollHeight - 1
      // 只有第一次到達底部時才設定 unlocked = true
      if (atBottom && !this.unlocked) {
        this.unlocked = true
        this.$emit('update:agree', true)
      }
    },
    emitAgree(val) {
      this.$emit('update:agree', val)
    },
  },
}
</script>

<style>
.terms-box {
  height: 300px;
  overflow-y: auto;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 10px;
  margin-bottom: 15px;
  background: #fafafa;
  line-height: 1.8;
}
.terms-text {
  white-space: pre-line; /* 這樣 \n 會顯示成斷行 */
}

.terms-checkbox-wrapper {
  margin-top: 4px;
  display: flex;
  justify-content: center;
}

.terms-checkbox-wrapper.is-readonly .el-checkbox.is-checked .el-checkbox__inner,
.terms-checkbox-wrapper.is-readonly .el-checkbox.is-checked.is-disabled .el-checkbox__inner {
  background-color: #ea6a2a;
  border-color: #ea6a2a;
}

.terms-checkbox-wrapper.is-readonly .el-checkbox.is-checked.is-disabled {
  opacity: 1;
  cursor: not-allowed;
}

.el-button[disabled],
.el-checkbox.is-disabled:not(.is-checked) {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>
